import React from "react";
import { Link } from "react-router-dom";
import { SuccessStory } from "./successStoriesData";

/**
 * SuccessStorySingle — 16:7 preview card rendered on /success-stories.
 * Links to /success-stories/:id, where SuccessStoryCard renders the full story.
 */
type Props = {
    story: SuccessStory;
};

const SuccessStorySingle: React.FC<Props> = ({ story }) => {
    return (
        <Link
            to={`/success-stories/${story.story_id}`}
            className="block group focus:outline-none"
            aria-label={`${story.client.name} — ${story.card_description.replace(/\n/g, " ")}`}
        >
            {/* ── Card wrapper ── */}
            <div
                className="relative w-full overflow-hidden md:aspect-[16/7]"

            >
                {/* Background image */}
                <img
                    src={`/success_stories/${story.story_id}/card.png`}
                    alt={story.mission.name}
                    onError={(e) => {
                        (e.currentTarget as HTMLImageElement).src = "/news/News0.png";
                    }}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                />

                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black/45 group-hover:bg-black/35 transition-colors duration-500" />

                {/* ── Content: logo left / description right ── */}
                <div
                    className="
                          relative md:absolute md:inset-0
        flex flex-col md:flex-row
        items-center justify-between
        px-8 sm:px-12 md:px-16 lg:px-20
        py-10 md:py-0
        gap-6 md:gap-0
                    "
                >
                    {/* LEFT — client logo */}
                    <div className="flex items-center justify-center md:justify-start w-full md:w-2/5 flex-shrink-0">
                        {story.client.logo ? (
                            <img
                                src={story.client.logo}
                                alt={story.client.name}
                                className="h-24 sm:h-22 md:h-22 lg:h-32 w-auto max-w-[420px] md:max-w-[480px] object-contain brightness-0 invert"
                                onError={(e) => {
                                    (e.currentTarget as HTMLImageElement).style.display = "none";
                                }}
                            />
                        ) : (
                            <span className="text-white text-2xl md:text-3xl font-bold uppercase tracking-tight">
                                {story.client.name}
                            </span>
                        )}
                    </div>

                    {/* RIGHT — mission description */}
                    <div className="w-full md:w-1/2 text-center md:text-right flex-shrink-0">
                        <p
                            className="
                                text-white font-bold uppercase tracking-tight leading-tight whitespace-pre-line
                                text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl
                            "
                        >
                            {story.card_description}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default SuccessStorySingle;
